export const GET_DISCOUNT_AND_PENALTY = 'GET_DISCOUNT_AND_PENALTY/get_discount_and_penalty';
export const UPDATE_DISCOUNT_AND_PENALTY = 'UPDATE_DISCOUNT_AND_PENALTY/update_discount_and_penalty';
